import { useMemo } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import messages from "./messages";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import RefrezhButton from "components/RefrezhButton";
import Base from "components/Message/Base";

const useStyles = makeStyles(theme => ({
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  body: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(2, 0),
  },
  messageBox: {
    borderLeft: "none",
    border: "1px solid rgba(0,0,0,0.24)",
    borderColor: "rgba(0,0,0,0.24)",
  },
  action: {
    marginTop: theme.spacing(2),
  },
}));

function GeneralMessage({
  onClose,
  onCloseMessage,
  activeMessage,
  showPatient,
}) {
  const classes = useStyles();

  const body = useMemo(
    () => (
      <div className={classes.body}>
        <Grid container>
          <Grid item xs={12}>
            <Typography display="block">{activeMessage.message}</Typography>
          </Grid>
          {activeMessage.status === 1 && (
            <Grid item xs={12} container justify="center" display="flex">
              <RefrezhButton
                className={classes.action}
                onClick={() => onCloseMessage(activeMessage.id)}
              >
                <FormattedMessage {...messages.general_message_read} />
              </RefrezhButton>
            </Grid>
          )}
        </Grid>
      </div>
    ),
    [
      activeMessage.id,
      activeMessage.message,
      activeMessage.status,
      classes.action,
      classes.body,
      onCloseMessage,
    ],
  );

  return (
    <Base
      onClose={onClose}
      shouldRenderPatient={showPatient}
      title={<FormattedMessage {...messages.general_message_title} />}
      activeMessage={activeMessage}
    >
      {body}
    </Base>
  );
}

GeneralMessage.propTypes = {
  onClose: PropTypes.func.isRequired,
  onCloseMessage: PropTypes.func.isRequired,
  activeMessage: PropTypes.shape({
    message: PropTypes.string,
  }),
};

export default withRouter(GeneralMessage);
